import { render, staticRenderFns } from "./NotSupport.vue?vue&type=template&id=62fbeaa7&scoped=true&"
import script from "./NotSupport.vue?vue&type=script&lang=js&"
export * from "./NotSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbeaa7",
  null
  
)

export default component.exports